<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="margin-top: 2%">
 <template>
            <v-row justify="center">
        <v-dialog v-model="dialogCommande" max-width="800px"  style="z-index: 1058">
                                           
                                           <v-card>
                                               <v-card-title>
                                                   <span class="headline">
                                                    Commande manuelle
                                                   </span>
                                               </v-card-title>

                                               <v-card-text>


                                                   <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                       <v-alert v-if="errors" dense outlined
                                                                :type="(errors.update_error)?'error':'success'">
                                                           {{errors.operation}}
                                                       </v-alert>

                                                       <v-text-field v-if="pharmaproduitalls==undefined" color="primary" loading
                                                                     disabled></v-text-field>
                                                                     
                                                    <v-row v-for="(item, index) in listproduit" v-bind:key="item"
                                                   :id="index+'row'">
                                                           <v-col cols="12" sm="6" md="6">
                                                        <v-autocomplete
                                                            
                                                                @change="(event) => updatelinelistproduitByProd(event, index)"
                                                                :value="item.produit_slug"
                                                                :items="pharmaproduitalls"
                                                                dense
                                                                chips
                                                                small-chips
                                                                item-text="produit.denomination"
                                                                item-value="produit._id"
                                                                label="Le produit"
                                                                placeholder="Choisissez le produit"
                                                                return-object
                                                        ></v-autocomplete>
                                                        </v-col>
                                                                              
                                                          
                                                           <v-col cols="12" sm="2" md="2" style=" margin-top: -3.5%;" >

                                                           <v-text-field
                                                           :value="item.pu"
                                                           readonly
                                                            filled
                                                                      
                                                                             label="PU en xof" >
                                                                             </v-text-field>

                                                            </v-col>

                                                            <v-col cols="12" sm="1" md="1" style=" margin-top: -2.5%;" >

                                                           <v-text-field
                                                                        :id="'qte'+index"
                                                                        type="number"
                                                                        min="1"
                                                                        @keyup="updatelinelistproduitByQte(index)"
                                                                       
                                                                       :value="item.qte"
                                                                             label="Qte" >
                                                                             </v-text-field>

                                                            </v-col>

                                                            <v-col cols="12" sm="2" md="2" style=" margin-top: -3.5%;" >

                                                           <v-text-field
                                                                        readonly
                                                                        filled
                                                                       :value="(item.pu*item.qte)"
                                                                             label="Total en xof" >
                                                                             </v-text-field>

                                                            </v-col>

                                                            <v-col v-if="index===0" cols="2" sm="1" md="1">
                                                            <v-btn @click="add_cqq" class="" fab dark small color="primary">
                                                                <v-icon dark>mdi-plus</v-icon>
                                                            </v-btn>
                                                            </v-col>
                                                    <v-col v-else cols="2" sm="1" md="1">
                                                        <v-btn class="" @click="remove_cqq(index)" fab dark small
                                                               color="red">
                                                            <v-icon dark>mdi-minus</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                           
                                                       </v-row>
                                                      

                             <v-text-field v-if="submitting" color="primary" loading
                                                                     disabled></v-text-field>
                                                   </v-form>
                            
                                               </v-card-text>

                                               <v-card-actions>
                                                   
                                                   <div class="container">
                                                   <div class="row">
                                                <div class="col-md-6">
                                                    <div class=" mini-stats-wid">
                                                        <div class="" style="background-color: #046089; padding: 2.2%">
                                                            <div class="media">
                                                                <div class="media-body text-center">
                                                                
                                                                    <h4 class="mb-0" style="color: white"> Total de la commande :  XOF {{totalCom}}  </h4>
                                                                   
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            <div class="col-md-6 text-right">
                                                <v-btn color="blue darken-1" text @click="dialogCommande = false">Annuler</v-btn>
                                                   <v-btn color="blue darken-1"  :disabled="totalCom==0" text @click="save">Sauvegarder</v-btn>
                                            </div>
                                            </div>
                                            </div>
                                                   
                                               </v-card-actions>
                                           </v-card>
                                       </v-dialog>
                                         </v-row>

        </template>

        <template>
            <v-row justify="center">
                <v-dialog v-model="dialog"  style="z-index: 1058" persistent max-width="850px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Les produits de la commande : {{refCom}} </span>
                             <v-chip color="primary"
                                                style="color: white; cursor:pointer;margin-left: 15px">
                                           Total :  {{order.total_price}} XOF
                                        </v-chip>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-data-table
                                        :headers="headers2"
                                        :items="produitComs"
                                        :search="search"
                                        sort-by="name"
                                        class="elevation-1"
                                        :loading="produitComs.length==0" loading-text="Chargement en cours...">


                                    <template v-slot:item.produit_img="{item}">
                                        <a v-if="item.produit_img" :href="item.produit_img.substr(7)" target="_blank">
                                            <img :src="item.produit_img.substr(7)"
                                                 style="width: 50px; height: 50px;cursor: pointer; margin: 2% "
                                                 data-toggle="modal" data-target="#infos"/>
                                        </a>
                                    </template>

                                    <template v-slot:item.prix_achat="{ item }">
                                        <p style="font-weight: bold; font-size: 10pt">{{item.prix_achat}} XOF</p>
                                    </template>


                                    <template v-slot:item._id="{ item }">
                                        <p style="font-weight: bold; font-size: 10pt">{{item.prix_achat * item.qte}}
                                            XOF</p>
                                    </template>




                                    <template v-slot:item.etat_get="{ item }">
                                        <v-chip :color="(item.etat_get!='false')?'green':'red'"
                                                style="color: white; cursor:pointer;">
                                            {{(item.etat_get=="false")?'En attente':'Déjà récupéré'}}
                                        </v-chip>
                                    </template>




                                    <template v-slot:no-data>
                                        <v-btn color="default" @click="initialize">Actualiser</v-btn>
                                    </template>
                                </v-data-table>
                            </v-container>
                              <v-text-field v-if="submitting" color="primary" loading
                                                                     disabled></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                            <v-btn v-if="setgetorder" color="blue darken-1" text @click="saveOrder">Récupérer la commande</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>

        </template>

        <v-card>
            <v-card-title v-if="createneworder">

                <v-row>
                    <div class="col-md-8 col-sm-8" >
                    <v-text-field
                            
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Rechercher une commande ..."
                            single-line
                            hide-details
                    ></v-text-field>
                    </div>
                    <div class="col-md-4 col-sm-4 text-right" >
                         <v-btn style="background: #2A3042;color: #fff" class="mb-2 " @click="showdialogCommande()">Nouvelle Vente manuelle  </v-btn>
                    </div>
                </v-row>
               
            </v-card-title>
              <v-card-title v-else>

                <v-text-field
                        class="col-md-12 col-sm-12"
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Rechercher une commande ..."
                        single-line
                        hide-details
                ></v-text-field>
               
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="precommandesManuel"
                    :search="search"
                    sort-by="name"
                    class="elevation-1"
                    :loading="precommandesManuel==undefined" loading-text="Chargement en cours...">

                <template v-slot:item.reference="{ item }">
                    <v-chip @click="listProd(item)" color="#046089" style="color: white; cursor:pointer;">
                        <v-icon small class="mr-2">
                            mdi-eye
                        </v-icon>
                        {{ item.reference }}
                    </v-chip>
                </template>

                <template v-slot:item.state_paye="{ item }">
                    <v-chip :color="(item.state_paye=='SUCCESS')?'green':'orange'" style="color: white; cursor:pointer;">{{
                        item.state_paye }}
                    </v-chip>
                </template>
                <template v-slot:item.pharma_get="{ item }">
                    <v-chip :color="(item.pharma_get!='false')?'green':'red'" style="color: white; cursor:pointer;">
                        {{(item.pharma_get=="false")?'En attente':'Déjà récupéré'}}
                    </v-chip>
                </template>

                <template v-slot:item.pharma_total="{ item }">
                    <h5 style="font-weight: bold">{{item.pharma_total}} XOF</h5>
                </template>


                <template v-slot:item.created_at="{item}">
                    {{ getformatDate(item.created_at)}}
                </template>
                <template v-slot:no-data>
                    <v-btn color="default" @click="initialize">Actualiser</v-btn>
                </template>
                                  
            </v-data-table>
        </v-card>

        <v-snackbar
                v-model="snackbar"
                timeout="2000"
        >
            {{ textSnack }}

            <template v-slot:action="{ attrs }">
                <v-btn
                        color="blue"
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                >
                    Fermer
                </v-btn>
            </template>
        </v-snackbar>


    </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
     import $ from "jquery";

    export default {
        name: "Precommande",
        data() {
            return {
                submitting: false,
                user: JSON.parse(localStorage.getItem("user")),
                roles:JSON.parse(localStorage.getItem("mineroles")),
                valid: false,
                lazy: false,
                errors: undefined,
                search: '',
                dialog: false,
                dialogCommande: false,
                id: undefined,
                snackbar: false,
                createneworder:false,
                setgetorder:false,
                textSnack: '',
                refCom: '',
                pharma_total: 0,
                pharma_other_get: 'false',
                listproduit:[{produit_slug:"",pu:1,qte:1,produit_img:"",produit_name:""}],
                precommande: '',
                produitComs: '',
                totalCom:0,
                order:'',
                headers: [
                    {
                        text: 'Référence',
                        align: 'start',
                        sortable: true,
                        value: 'reference',
                    },
                    {text: 'Agent', value: 'client_slug.name', sortable: false},
                    {text: 'Contact d\'urgence', value: 'phone_client', sortable: false},
                    {text: 'Etat paiement', value: 'state_paye', sortable: false},
                    {text: 'Réception client', value: 'pharma_get', sortable: false},
                    {text: 'Montant payé', value: 'pharma_total', sortable: false},
                    {text: 'Date', value: 'created_at', sortable: false},

                ],
                headers2: [
                    {
                        text: 'Image',
                        align: 'start',
                        sortable: true,
                        value: 'produit_img',
                    },
                    {text: 'Produit', value: 'produit_name', sortable: false},
                    {text: 'Prix d\'achat', value: 'prix_achat', sortable: false},
                    {text: 'Quantité', value: 'qte', sortable: false},
                    {text: 'Réception client', value: 'etat_get', sortable: false},
                    {text: 'Sous Total', value: '_id', sortable: false},

                ],
                editedIndex: -1,
                editedItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                }

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle catégorie" : "Mise à jour"
            }
            ,
            ...mapState('precommandes/', ['precommandesManuel']),
             ...mapState('pharmaproduits/', ['pharmaproduitalls','overlay']),

        }
        ,
        mounted() {
            if (this.user.type_compte == "pharmacie")
            {
                if (this.roles.includes("CCM")){
                   this.createneworder = true;
                }
                 if (this.roles.includes("VCM")){
                   this.setgetorder = true;
                }
            }else{ this.$router.push("permission");}

            console.log("this.listproduit",this.listproduit);
            let data = new FormData();
            data.append("state_client_get", "false");
            data.append("pharma_get", "false");
            data.append("pharmacie", this.user.relation._id);
            this.$store.dispatch('precommandes/getPrecommandesManuel', data).then(response => {
                window.console.log('precommandes', response)
            });

            let data2 = new FormData();
            data2.append("id", this.user.relation._id);
            this.$store.dispatch('pharmaproduits/getPharmaProduitAlls', data2).then(response => {
                window.console.log('pharmaproduits', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
            dialogCommande(val){
                 val || this.close()
            },
            
        },
        methods: {
            initialize() {

            },
            calculTotal(){
                let tabvalid = [];
                let sum = 0;
                for(let i=0; i<this.listproduit.length; i++)
                {
                    sum += (this.listproduit[i].qte*this.listproduit[i].pu)
                }
                 this.totalCom = sum
                for(let i=0; i<this.listproduit.length; i++)
                {
                    if(this.listproduit[i].produit_slug=="")
                    {
                        tabvalid[i] = false;
                    }else{
                        tabvalid[i] = true;
                    }
                }
                if(tabvalid.includes(false)){
                    this.totalCom = 0;
                }
            },
            listProd(item) {
                this.order = item;
                this.produitComs = item.all_precommande_produit;
                this.refCom = item.reference;
                this.pharma_total = item.pharma_total;
                this.pharma_other_get = item.pharma_other_get;
                this.precommande = item._id;
                this.dialog = true;
            },
            updatelinelistproduitByProd(produitchoose,index){
                this.listproduit[index].produit_slug = produitchoose.produit._id;
                this.listproduit[index].pu = parseInt(produitchoose.prix);
                this.listproduit[index].produit_img = produitchoose.produit.photo;
                this.listproduit[index].produit_name = produitchoose.produit.denomination;
                this.calculTotal();
                console.log("this.listproduit",this.listproduit);
            },
            updatelinelistproduitByQte(index){
                this.listproduit[index].qte = ($("#qte"+index).val()==undefined || $("#qte"+index).val()==0)?1:$("#qte"+index).val();
                 this.calculTotal();
                console.log("this.listproduit",this.listproduit);
            },
            showdialogCommande(){
                this.totalCom = 0;
                 this.listproduit = [{produit_slug:"",pu:1,qte:1,produit_img:"",produit_name:""}]
                this.dialogCommande = true;
                this.valid = false;
                console.log("valid",this.valid);
            },
            add_cqq() {
                 this.listproduit.push({produit_slug:"",pu:1,qte:1,produit_img:"",produit_name:""});
                 this.calculTotal();

            },
            remove_cqq(index) {
                this.listproduit.splice(index, 1); 
                 this.calculTotal();
                $("#" + index + 'row').remove();
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {

                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir enregistrer cette commande ? L'action est irréversible.",
                    confirmButtonText: "Oui, je confirme",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                })
                    .then(result => {
                        if (result.value) {
                            this.submitting = true;
                            let data = new FormData();
                            data.append("listproduit", JSON.stringify(this.listproduit));
                            data.append("user_pharma", this.user._id);
                            data.append("total", this.totalCom);
                            data.append("pharmacie", this.user.relation._id);
                            data.append("pharmacie_name", this.user.relation.nom);
                            
                            let mineroute = 'precommandes/setPrecommandeManuel';
                            this.$store.dispatch(mineroute, data).then((response) => {
                                console.log('response', response);
                                this.snackbar = true;
                                this.textSnack = response.data.message;
                                this.submitting = false;
                                if (response.error) {
                                    this.errors.operation = response.data.message;
                                } else {
                                    this.dialogCommande  = false
                                }
                            });
                        }
                    })



            },
            saveOrder() {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir confirmé cette commande ? L'action est irréversible.",
                    confirmButtonText: "Oui, je confirme",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                })
                    .then(result => {
                        if (result.value) {
                            this.submitting = true;
                            let tabId = [];
                            let tabProdId = [];
                            let tabProdQte = [];
                            for (let i = 0; i < this.produitComs.length; i++) {
                                tabId[i] = this.produitComs[i]._id;
                                tabProdId[i] = this.produitComs[i].produit_slug;
                                tabProdQte[i] = this.produitComs[i].qte;
                            }


                            let data = new FormData();
                            data.append("tab", JSON.stringify(tabId));
                            data.append("tabProd", JSON.stringify(tabProdId));
                            data.append("tabProdQte", JSON.stringify(tabProdQte));
                            data.append("user", this.user._id);
                            data.append("state_client_get", "false");
                            data.append("pharmacie", this.user.relation._id);
                            data.append("pharma_get", "false");
                            data.append("pharma_total", this.pharma_total);
                            data.append("pharma_other_get", this.pharma_other_get);
                            data.append("precommande", this.precommande);
                            let mineroute = 'precommandes/setPrecommandeCours';
                            this.$store.dispatch(mineroute, data).then((response) => {
                                console.log('response', response);
                                this.snackbar = true;
                                this.textSnack = response.data.message;
                                this.submitting = false;
                                if (response.error) {
                                    this.errors.operation = response.data.message;
                                } else {
                                   this.dialog = false;
                                }
                            });
                           // this.dialog = false;
                        }
                    })



            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor() {
                return "#009587";
            },
            getformatDate(value) {
                if (value) {
                    return Intl.DateTimeFormat('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"
                    }).format(new Date(value));
                }
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>